import moment from "moment";
import currency from "currency.js";
import {
  GetRfqs200ResponseBlocksInnerLegsInner,
  InstrumentTypeResponse,
  SideResponse,
} from "../../../../codegen-api";
import { COLORS } from "../../../../constants/design/colors";
import { AssetTag, Ratio } from "../RFQTable/style";
import { nanosToSeconds } from "../../../../utils/date";
import TickerLogo from "../../../../components/shared/TickerLogo";

export function buildLegTag(
  leg: GetRfqs200ResponseBlocksInnerLegsInner,
  tagSide: (legSide: SideResponse) => SideResponse
): Array<string | JSX.Element> {
  if (leg.instrument_type === InstrumentTypeResponse.Option) {
    return [
      <AssetTag key={leg.instrument_id}>
        <TickerLogo asset={leg.asset} size={24} />
        {leg.asset}
      </AssetTag>,
      <span
        key={leg.instrument_id}
        style={{
          color:
            tagSide(leg.side) === SideResponse.Buy
              ? COLORS.up.one
              : COLORS.down.one,
        }}
      >
        {tagSide(leg.side)}
      </span>,
      leg.option_type as string,
      moment.unix(nanosToSeconds(Number(leg.expiry))).format("DD MMM YYYY"),
      currency(leg.strike as string, { precision: 0 }).format(),
      <Ratio key={leg.instrument_id}>x{leg.ratio}</Ratio>,
    ];
  }
  return [
    <AssetTag key={leg.instrument_id}>
      <TickerLogo asset={leg.asset} size={24} />
      {leg.asset}
    </AssetTag>,
    <span
      key={leg.instrument_id}
      style={{
        color:
          tagSide(leg.side) === SideResponse.Buy
            ? COLORS.up.one
            : COLORS.down.one,
      }}
    >
      {tagSide(leg.side)}
    </span>,
    leg.instrument_type,
    <Ratio key={leg.instrument_id}>x{leg.ratio}</Ratio>,
  ];
}
